module.exports = __webpack_public_path__ + "img/overview_info1.5f966301.jpg";